module.exports = __webpack_public_path__ + "img/logo.502127e0.png";